export const EASE: [number, number, number, number] = [0.16, 1, 0.3, 1];

export const viewportOnce = { once: true, amount: 0.15 } as const;
